module.exports = __webpack_public_path__ + "static/media/all-operating-systems-icon.aec3d535.svg";